"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlotMachineContextProvider = SlotMachineContextProvider;
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = require("react");
var _Executor = _interopRequireDefault(require("../utils/Executor"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SlotMachineContext = /*#__PURE__*/(0, _react.createContext)({
  wheels: [],
  onFrontPosterChange: () => {},
  onExecute: () => {},
  stopExecute: () => {},
  addWheel: () => {},
  setWheels: () => {},
  removeWheel: () => {},
  isExecuting: false // if the slot machine is executing
});
function SlotMachineContextProvider(_ref) {
  let {
    children
  } = _ref;
  const [wheels, setWheels_] = (0, _react.useState)([]);
  const [isExecuting, setIsExecuting] = (0, _react.useState)(false);
  const wheelsFrontPoster = (0, _react.useRef)([]);
  const executor = (0, _react.useRef)(null);
  const onFrontPosterChange = (idx, item) => {
    wheelsFrontPoster.current = [...wheelsFrontPoster.current.filter(i => i.idx !== idx), {
      idx,
      item
    }];
  };
  const onExecute = () => {
    const setters = {
      setIsExecuting: setIsExecuting,
      setWheels: setWheels_
    };
    executor.current = new _Executor.default(wheels, wheelsFrontPoster.current, setters);
    executor.current.execute();
  };
  const stopExecute = () => {
    var _executor$current;
    (_executor$current = executor.current) === null || _executor$current === void 0 || _executor$current.stop();
  };
  const setWheels = wheels => {
    setWheels_(wheels);
  };
  const addWheel = wheel => {
    if (wheels.length > 4) return;
    setWheels_(prev => [...prev, wheel]);
  };
  const removeWheel = idx => {
    setWheels_(prev => prev.filter((_, i) => i !== idx));

    // also remove the front poster
    wheelsFrontPoster.current = wheelsFrontPoster.current.filter(i => i.idx !== idx);
  };
  const context = {
    wheels,
    onFrontPosterChange,
    onExecute,
    stopExecute,
    addWheel,
    removeWheel,
    isExecuting,
    setWheels
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SlotMachineContext.Provider, {
    value: context,
    children: children
  });
}
var _default = exports.default = SlotMachineContext;